export default __webpack_public_path__ + "static/media/schedule.7307847c.png";